import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@ngneat/transloco';
import { VehicleWorkshop } from 'app/core/vehicle-workshop/vehicle-workshop.types';

/**
 * Selector de UN taller activo para usuarios rol WORKSHOP.
 *
 * @input  workshops       — lista de talleres del usuario
 * @input  selectedId      — _id del taller actualmente activo (opcional)
 * @output selectionChange — emite el _id del taller elegido
 *
 * Uso:
 *   <app-select-workshops
 *     [workshops]="user.workshops"
 *     [selectedId]="workshopFilterService.selectedWorkshopId()"
 *     (selectionChange)="onWorkshopChange($event)"
 *   />
 */
@Component({
  selector: 'app-select-workshops',
  standalone: true,
  templateUrl: './select-workshops.component.html',
  styleUrls: ['./select-workshops.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatFormFieldModule, MatSelectModule, MatOptionModule, TranslocoModule],
})
export class SelectWorkshopsComponent {
  /** Lista de talleres disponibles para este usuario. */
  workshops = input<VehicleWorkshop[]>([]);

  /** _id del taller activo (binding externo, ej. desde WorkshopFilterService). */
  selectedId = input<string | null>(null);

  /** Emite el _id del taller seleccionado cada vez que cambia. */
  selectionChange = output<string>();

  onSelectionChange(event: MatSelectChange): void {
    this.selectionChange.emit(event.value as string);
  }
}
